import React, {PureComponent, Fragment} from 'react'
import PropTypes from 'prop-types'
import NumberSettingsContext from './NumberSettingsContext'
import TextField from 'components/TextField'
import {displayNumber, normalizeNumber} from 'utils'
import StyleSheet from 'styles'

export class NumberField extends PureComponent {
  static propTypes = {
    thousandsSeparator: PropTypes.string,
    decimalSeparator: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }

  static defaultProps = {
    thousandsSeparator: ' ',
    decimalSeparator: '.',
  }

  state = {active: false, transition: false}

  get value() {
    const {value, thousandsSeparator, decimalSeparator} = this.props
    return displayNumber(value, {thousandsSeparator, decimalSeparator})
  }

  get inputWidth() {
    return this.inputRef ? this.inputRef.clientWidth : 0
  }

  get textWidth() {
    return this.measureRef ? this.measureRef.clientWidth : 0
  }

  get inputStyles() {
    if (this.state.transition) {
      return {paddingLeft: this.inputWidth - this.textWidth}
    }
    return undefined
  }

  handleCaretChange = () => {
    this.oldCaretIndex = this.inputRef.selectionStart
  }

  componentDidUpdate() {
    if (this.caretIndex || this.caretIndex === 0)
      this.inputRef.setSelectionRange(this.caretIndex, this.caretIndex)
  }

  processValue = (newValue) => {
    const {thousandsSeparator, decimalSeparator} = this.props
    if (normalizeNumber(newValue) === this.props.value) {
      newValue = this.processDelete(newValue)
    }
    else {
      this.updateCaretIndex(newValue)
    }

    return normalizeNumber(newValue, {thousandsSeparator, decimalSeparator})
  }

  spaceDif = (newValue) => {
    const {value, thousandsSeparator} = this.props
    const current = this.inputRef.selectionStart
    const previous = this.oldCaretIndex

    const oldSpaces = displayNumber(value).substr(0, previous).split(thousandsSeparator).length - 1
    const newSpaces = displayNumber(newValue).substr(0, current).split(thousandsSeparator).length - 1

    return newSpaces - oldSpaces
  }

  updateCaretIndex = (newValue) => {
    const current = this.inputRef.selectionStart

    this.caretIndex = current + this.spaceDif(newValue)
  }

  processDelete(newValue) {
    const {thousandsSeparator, decimalSeparator} = this.props

    const backspace = this.oldCaretIndex > this.inputRef.selectionStart
    const deleteIndex = 2 + (backspace ? 1 : 0)

    const [left, right] = newValue.split(decimalSeparator)

    return left.split(thousandsSeparator).map((block) => {
      if (block.length > 3) {
        this.caretIndex = this.oldCaretIndex + (backspace ? this.spaceDif(newValue) - 1 : 1)
        return block.slice(0, block.length - deleteIndex - 1) + block.slice(block.length - deleteIndex)
      }
      else {
        return block
      }
    }).join('') + (right ? (decimalSeparator + right) : '')
  }

  onChange = ({target: {value}}) => {
    const {decimalSeparator} = this.props
    if (value.lastIndexOf(decimalSeparator) === value.indexOf(decimalSeparator)) {
      this.props.onChange({target: {value: this.processValue(value)}})
    }
  }

  handleActive = (active) => () => {
    if (this.props.disabled)
      return

    if (!active) {
      this.inputRef.style.transition = "none"
    }
    this.setState({active: false, transition: true, changeRef: {}}, () => {
      setTimeout(() => {
        this.inputRef.style.transition = ""
        this.setState({active, transition: false, changeRef: null})
      }, active ? 450 : undefined)
    })
  }

  handleTransition = (transition) => () => {
    if (this.props.disabled)
      return

    if (!this.state.active && !this.state.changeRef)
      this.setState({transition})
  }

  render = () => {
    const {thousandsSeparator, decimalSeparator, inputProps, ...props} = this.props
    const {active, transition} = this.state
    return (
      <Fragment>
        <TextField {...props} value={this.value} onChange={this.onChange} inputRef={ref => this.inputRef = ref}
                   inputProps={{...inputProps, className: styles({input: true, active, transition}), style: this.inputStyles}} onClick={this.handleCaretChange}
                   onKeyUp={this.handleCaretChange} onKeyDown={this.handleCaretChange}
                   onMouseOver={this.handleTransition(true)} onMouseLeave={this.handleTransition(false)}
                   onFocus={this.handleActive(true)} onBlur={this.handleActive(false)}/>

        <div className={styles.textMeasure} ref={ref => this.measureRef = ref}>{this.value}</div>
      </Fragment>
    )
  }

}

export default class NumberFieldWrapper extends PureComponent {
  render = () =>
    <NumberSettingsContext.Consumer>{value => <NumberField {...value} {...this.props} />}</NumberSettingsContext.Consumer>
}

const styles = StyleSheet({
  input: {
    'div&': {
      padding: '0 !important'
    },
    transition: 'padding 300ms',
    transitionDelay: '150ms',
    boxSizing: 'border-box',
    paddingLeft: 0,
    '&$active': {
      textAlign: 'right',
    },
  },
  textMeasure: {
    position: 'absolute',
    display: 'inline-block',
    padding: 0,
    whiteSpace: 'nowrap',
    visibility: 'hidden',
    fontWeight: 500,
    fontSize: '16px',
  },
  active: {}
})